import SHRolePicker from './src/picker.vue';

/* istanbul ignore next */
SHRolePicker.install = function(Vue) {
  Vue.component('sh-role-picker', SHRolePicker);
};

export default SHRolePicker;



// WEBPACK FOOTER //
// ./src/components/base/view/Org/cmps/role/picker/index.js